import React from 'react'

interface ArrowUpUnderlineProps {
  size?: number
  color?: string
}

export const ArrowUpUnderline: React.FC<ArrowUpUnderlineProps> = ({
  size = 24,
  color = '#000',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9293 1.65653C11.9683 1.61747 12.0317 1.61747 12.0707 1.65653L17.8535 7.43936C18.0488 7.63462 18.0488 7.95121 17.8535 8.14647L17.1465 8.85355C16.9512 9.04881 16.6346 9.04881 16.4393 8.85355L13 5.41424V14.5C13 14.7761 12.7761 15 12.5 15H11.5C11.2239 15 11 14.7761 11 14.5V5.41424L7.56066 8.85355C7.3654 9.04881 7.04882 9.04881 6.85356 8.85355L6.14645 8.14647C5.95119 7.95121 5.95118 7.63462 6.14645 7.43936L11.9293 1.65653ZM3 18V14.9999C3 14.7237 3.22386 14.4999 3.5 14.4999H4.5C4.77614 14.4999 5 14.7237 5 14.9999V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18V14.9999C19 14.7237 19.2239 14.4999 19.5 14.4999H20.5C20.7761 14.4999 21 14.7237 21 14.9999V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18Z"
        fill={color}
      />
    </svg>
  )
}
